import React, {Component} from 'react';
import Select from "../../elements/components/form/Select"
import PrimaryButton from "../../elements/components/Buttons/PrimaryButton";
import Switch from "../../elements/components/form/Switch";
import LocationInput from "./LocationInput";
import ArrivalDepartureInputs from "./ArrivalDepartureInputs";
import PriceForNightFilter from "./PriceForNightFilter";
import RoomCountFilter from "./RoomCountFilter";
import AmenitiesFilter from "./AmenitiesFilter";
import {filtersList, DEFAULT_FILTERS} from '../filtersList';
import '@assets/sass/search-results/filters.scss';
import ReactGA from '../../utils/react-ga'

export default class SearchFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            advancedFilters: false,
            apartmentsCount: this.props.apartmentsCount,
            checkedAllAmenities: false,
        };
        this.handleFiltersTrigger = this.handleFiltersTrigger.bind(this);
    }

    handleFiltersTrigger(shouldBeExpanded) {
        if (shouldBeExpanded) {
            ReactGA.event({
                category: 'Wyszukiwarka apartamentów',
                action: 'Klik pokaż filtry'
            })
        }

        this.setState({
            advancedFilters: shouldBeExpanded,
        })

        this.props.onAdvancedFiltersClick(true);
    }

    static getDerivedStateFromProps(props, current_state) {
        if (current_state.apartmentsCount !== props.apartmentsCount) {
            return {
                apartmentsCount: props.apartmentsCount
            }
        }
        return null;
    }

    handleChangeGuestsNumber = e => {
        this.props.onChangeFilter({guests_number: e});
    }

    handleChangeFilters = (filter) => {
        this.props.onChangeFilter(filter)
    }

    handleSelectAllAmenities = () => {
        const filters = {};

        filtersList.forEach(checkboxKey => {
            filters[Object.values(checkboxKey)[0]] = true
        })

        this.setState({
            checkedAllAmenities: true,
        })

        this.props.onChangeFilter(filters);
    }

    handleDeselectAllAmenities = () => {
        const filters = {};

        filtersList.forEach(checkboxKey => {
            filters[Object.values(checkboxKey)[0]] = undefined
        })

        this.setState({
            checkedAllAmenities: true,
        }, () => {
            this.setState({
                checkedAllAmenities: false,
            })
        })

        this.props.onChangeFilter(filters);
    }

    handleClearFilters = () => {
        const filters = {};

        filtersList.forEach(checkboxKey => {
            filters[Object.values(checkboxKey)[0]] = undefined
        })

        this.setState({
            checkedAllAmenities: true,
        }, () => {
            this.setState({
                checkedAllAmenities: false,
            })
        })

        this.props.onChangeFilter({...filters, ...DEFAULT_FILTERS});

        document.getElementById('priceMin').value = '';
        document.getElementById('priceMax').value = '';
    }

    getFiltersLabel = () => {
        const {translations, windowScrolled} = this.props;

        if (!this.state.advancedFilters || windowScrolled) {

            if (window.innerWidth < 992) {
                return translations['filter']
            } else {
                return translations['show-filters']
            }

        } else {

            if (window.innerWidth < 992) {
                return translations['filter']
            } else {
                return translations['hide-filters']
            }
        }
    }

    getMapLabel = () => {
        const {translations} = this.props;

        if (!this.props.mapExpanded) {
            if (window.innerWidth < 992) {
                return translations['map']
            } else {
                return translations['show-map']
            }

        } else {

            if (window.innerWidth < 992) {
                return translations['map']
            } else {
                return translations['hide-map']
            }
        }

    }

    scrollIntoResults = () => {
        const searchResults = document.getElementById('search-results');
        searchResults.scrollIntoView(true);
        window.scrollBy(0, -70)
    }

    handleSearchClick = (e) => {
        if (window.innerWidth < 768) {
            this.scrollIntoResults();
            this.props.onClickSearch();
        } else {
            const {from, to} = this.arrivalDepartureInputs.state;
            this.arrivalDepartureInputs.changeDateFilter();
        }
    }

    renderFiltersBasic = () => {
        const {
            onMapTriggerClick,
            initialFilters,
            filtersCount,
            translations,
            onSearchFiltersScroll,
            mapExpanded,
            filters: {
                guests_number
            }
        } = this.props;
        const {advancedFilters} = this.state;
        const initialLocation = initialFilters.location;
        const initialBookingDate = {
            from: initialFilters.date_from,
            to: initialFilters.date_to
        }

        return (
            <div
                className={"search-filters__basic" + (advancedFilters ? ' search-filters__basic--withAdvanced' : '')}>
                <LocationInput
                    initialValue={initialLocation}
                    onChangeFilter={this.props.onChangeFilter}
                    translations={translations}
                />
                <ArrivalDepartureInputs
                    initialDates={initialBookingDate}
                    onChangeFilter={this.props.onChangeFilter}
                    translations={translations}
                    onRef={ref => (this.arrivalDepartureInputs = ref)}
                />
                <div className="guestsNumber">
                    <label className="filter-title">{translations['visitors']}</label>
                    <Select
                        initialValue={initialFilters.guests_number || 2}
                        optionsAmount={8}
                        onChange={this.handleChangeGuestsNumber}
                        isSearchable={false}
                    />
                </div>
                <div className="filter-wrapper">
                    <div className="filter-switch">
                            <span className="filter-switch__label">
                                {this.getFiltersLabel()}
                            </span>
                        <div className="filter-switch__wrapper">
                            <Switch
                                onChange={this.handleFiltersTrigger}
                                counter={filtersCount}
                                defaultCount={0}
                                checked={this.state.advancedFilters}
                                onChecked={this.handleSwitcherChecked}
                                windowScrolled={this.props.windowScrolled}
                                onSwitcherScroll={onSearchFiltersScroll}
                            />
                        </div>
                    </div>

                    <div className="filter-switch">
                            <span className="filter-switch__label">
                                {this.getMapLabel()}
                            </span>
                        <div className="filter-switch__wrapper">
                            <Switch
                                onChange={onMapTriggerClick}
                                uniqueID="mapTrigger"
                                windowScrolled={this.props.windowScrolled}
                                onSwitcherScroll={onSearchFiltersScroll}
                                checked={mapExpanded}
                            />
                        </div>
                    </div>

                </div>
                <PrimaryButton
                    onClick={this.handleSearchClick}
                    text={translations['search']}
                />
            </div>
        )
    }

    render() {
        const {
            translations
        } = this.props;

        return (
            <div className={"search-filters"}>
                {this.renderFiltersBasic()}
                <div
                    className={"search-filters__advanced" +
                    (this.state.advancedFilters ? ' search-filters__advanced--expanded' : '')
                    }>
                    <div className="filters-column">
                        <div className="filters-row">
                            <div className="filters-row__item">
                                <PriceForNightFilter
                                    translations={translations}
                                    onChangeFilter={this.props.onChangeFilter}
                                />
                            </div>
                            <div className="filters-row__item">
                                <RoomCountFilter
                                    translations={translations}
                                    onChangeFilter={this.props.onChangeFilter}
                                    minValue={this.props.filters.roomMin}
                                    maxValue={this.props.filters.roomMax}
                                />
                            </div>
                        </div>
                        <div className="filters-row">
                            <AmenitiesFilter
                                translations={translations}
                                onChangeFilter={this.handleChangeFilters}
                                disabled={false}
                                checkedAll={this.state.checkedAllAmenities}
                                selectAllAmenities={this.handleSelectAllAmenities}
                                deselectAllAmenities={this.handleDeselectAllAmenities}
                                apartmentsCount={this.state.apartmentsCount}
                                onClearFilters={this.handleClearFilters}
                            />

                        </div>
                        <div className="filters-row">
                            <input type="hidden" name="nw-lat" value=""/>
                            <input type="hidden" name="nw-lng" value=""/>
                            <input type="hidden" name="ne-lat" value=""/>
                            <input type="hidden" name="ne-lng" value=""/>
                            <input type="hidden" name="se-lat" value=""/>
                            <input type="hidden" name="se-lng" value=""/>
                            <input type="hidden" name="sw-lat" value=""/>
                            <input type="hidden" name="sw-lng" value=""/>
                        </div>
                    </div>
                    <div className="filters-column">
                        <div className="search-filters__summary hidden-xs">
                            <h4
                                className="search-filters__clear-filters"
                                onClick={this.handleClearFilters}
                            >
                                {translations['clear-filters']}
                            </h4>
                            <h3 className="search-filters__score">
                                {this.state.apartmentsCount + " " + translations['filters.x-found']}
                            </h3>
                        </div>
                    </div>
                </div>
                {this.props.children}
            </div>
        )
    }
}
